export default {
    setPage(state: { page_allowed: Array<any> }, data: Array<any>) {
        state.page_allowed = data;
    },
    setDisabledPage(state: { page_disabled: Array<any> }, data: Array<any>) {
      state.page_disabled = data;
    },
    setMoneyHash(state: { money_hash: any }, data: any) {
      state.money_hash = data;
    },
    setSoloLoyalty(state: { solo_loyalty: any }, data: any) {
      state.solo_loyalty = data;
    },
    setWhatsApp(state: { whats_app : any }, data: any ) {
      state.whats_app = data
    },
    setIsRefresh(state: { is_refresh : any }, data: any) {
      state.is_refresh += data
    },
    setIsWhatsAppVerified(state: { is_whatsapp_verified : any }, data: any) {
      state.is_whatsapp_verified = data;
    },
    setIsWhatsAppOnBoarded(state: { is_whatsapp_onboarded : any }, data: any) {
      state.is_whatsapp_onboarded = data;
    }
}
